(function () {
  function init(root) {
    if (!root || root.dataset.c03Initialized === 'true') return;
    root.dataset.c03Initialized = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-c03-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-c03-panel]'));

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-c03-tab');
        tabs.forEach(function (item) { item.setAttribute('aria-selected', item === tab ? 'true' : 'false'); });
        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-c03-panel') === key;
          panel.hidden = !isActive;
          if (isActive) {
            var gallery = panel.querySelector('[data-c03-gallery]');
            if (gallery) gallery.scrollTo({ left: 0, behavior: 'auto' });
          }
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-c03-guide]').forEach(init);
    initMotion();
  }

  function initMotion() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('.c03-waterless-guide'));
    if (!roots.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var items = [];
    roots.forEach(function (root) {
      root.classList.add('c03-motion-ready');
      Array.prototype.slice.call(root.querySelectorAll('.c03-container > *, .c03-technology__card, .c03-diffuser-card, .c03-trust-card, .c03-faq__item')).forEach(function (item, index) {
        item.classList.add('c03-animate-item');
        item.style.setProperty('--c03-motion-delay', Math.min(index * 70, 420) + 'ms');
        items.push(item);
      });
    });

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('c03-in-view'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('c03-in-view');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: .12 });

    items.forEach(function (item) { observer.observe(item); });
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('[data-c03-guide]') : null;
    init(root);
    initMotion();
  });
})();
